export const messages = {
  en: {
    shopDetail: {
      shopInfo: 'Shop Information',
      shopNumber: 'Shop Number',
      location: 'Location',
      builtUpArea: 'Built-up Area',
      shopArea: 'Indoor Area',
      rent: 'Rent',
      state: 'Status',
      leasePeriod: 'Lease Period',
      owner: 'Owner',
      room: 'Room',
      contact: 'Contact',
      remark: 'Remark',
      member: 'Member',
      car: 'Vehicle',
      shop: 'Shop',
      idle: 'Idle',
      rented: 'Rented',
      sold: 'Sold'
    },
    shopDetailShop: {
      shopNumberPlaceholder: 'Please enter shop number',
      shopNumber: 'Shop Number',
      location: 'Location',
      owner: 'Owner',
      contact: 'Contact',
      area: 'Area',
      state: 'Status',
      idle: 'Idle',
      rented: 'Rented',
      sold: 'Sold'
    },
    shopDetailOwner: {
      ownerId: 'Owner ID',
      name: 'Name',
      gender: 'Gender',
      personType: 'Person Type',
      personRole: 'Person Role',
      idCard: 'ID Card',
      contact: 'Contact',
      backupPhone: 'Backup Phone',
      remark: 'Remark'
    }
  },
  zh: {
    shopDetail: {
      shopInfo: '商铺详情',
      shopNumber: '商铺编号',
      location: '位置',
      builtUpArea: '建筑面积',
      shopArea: '室内面积',
      rent: '租金',
      state: '状态',
      leasePeriod: '租赁期限',
      owner: '业主',
      room: '房屋',
      contact: '联系方式',
      remark: '备注',
      member: '成员',
      car: '车辆',
      shop: '商铺',
      idle: '空闲',
      rented: '已出租',
      sold: '已售'
    },
    shopDetailShop: {
      shopNumberPlaceholder: '请输入商铺编号',
      shopNumber: '商铺编号',
      location: '位置',
      owner: '业主',
      contact: '联系方式',
      area: '面积',
      state: '状态',
      idle: '空闲',
      rented: '已出租',
      sold: '已售'
    },
    shopDetailOwner: {
      ownerId: '业主ID',
      name: '名称',
      gender: '性别',
      personType: '人员类型',
      personRole: '人员角色',
      idCard: '证件号',
      contact: '联系方式',
      backupPhone: '备用手机',
      remark: '备注'
    }
  },
  'zh-TW': {
    shopDetail: {
      shopInfo: '商鋪詳情',
      shopNumber: '商鋪編號',
      location: '位置',
      builtUpArea: '建築面積',
      shopArea: '室內面積',
      rent: '租金',
      state: '狀態',
      leasePeriod: '租賃期限',
      owner: '業主',
      room: '房屋',
      contact: '聯絡方式',
      remark: '備註',
      member: '成員',
      car: '車輛',
      shop: '商鋪',
      idle: '空閒',
      rented: '已出租',
      sold: '已售'
    },
    shopDetailShop: {
      shopNumberPlaceholder: '請輸入商鋪編號',
      shopNumber: '商鋪編號',
      location: '位置',
      owner: '業主',
      contact: '聯絡方式',
      area: '面積',
      state: '狀態',
      idle: '空閒',
      rented: '已出租',
      sold: '已售'
    },
    shopDetailOwner: {
      ownerId: '業主ID',
      name: '名稱',
      gender: '性別',
      personType: '人員類型',
      personRole: '人員角色',
      idCard: '證件號',
      contact: '聯絡方式',
      backupPhone: '備用手機',
      remark: '備註'
    }
  }
}
